import settings from '../utils/settings';

/**
 * Set the SEM configuration for production environment.
 */
const configProd = {
  serviceDomain: 'https://sem-content.healthcare.com',
  session: 'https://session-manager-srv.healthcare.com/session',
  plans: 'https://plans-srv.healthcare.com',
  featureAds: 'https://searchads.healthcare.com/api/searchads',
  rotationToolAds: 'https://rotation-tool-srv.healthcare.com/feed/search',
};

/**
 * Set the SEM configuration for staging environment.
 */
const configStgDev = {
  // serviceDomain: 'http://localhost:8001',
  serviceDomain: 'https://sem-content.stg.healthcare.com',
  session: 'https://session-manager-srv.stg.healthcare.com/session',
  plans: 'https://plans-srv.stg.healthcare.com',
  featureAds: 'https://searchads.stg.healthcare.com/api/searchads',
  rotationToolAds: 'https://rotation-tool-srv.stg.healthcare.com/feed/search',
};

const configQA = {
  ...configStgDev,
  serviceDomain: 'https://sem-content.qa.healthcare.com',
};

const configStgProd = settings.isProd ? configProd : configStgDev;
const config = (settings.isDev || settings.isQa) ? configQA : configStgProd;

export default config;
